export enum BILL_TYPE {
    add = 'ADD',
    rent = 'RENT',
    pkg = 'PACKAGE',
    deposit = 'DEPOSIT',
    installment = 'INSTALLMENT'    
}